<template>
<div>
    <div class="row">
        <div class="col-sm-12">
            <google-map :userdetails="PartnerList" ref="googleMap" @before-open="beforeOpen" :infoType="'eRemitPayPartnersGeo'" @OnMarkerSelect="onMapMarkerSelect" @OnSearchMap="onSearchMap"></google-map>
        </div>
    </div>
    <div class="partner-info-details">
        <div class="row" v-for="item in PartnerList" :key="item.Id" style="font-size: 14px !important;">
            <div class="col-md-8 partner-address">
                <p><strong><i class="fas fa-map-marker text-danger" aria-hidden="true"></i> {{item.TerminalName}}</strong></p>
                <span>{{item.Address}}</span>
                <p><i class="fas fa-phone text-danger" aria-hidden="true"></i> <span>{{item.PhoneNumber}}</span></p>
            </div>
            <div class="col-md-4 text-right">
                <p>{{item.Distance}}</p>
                <span class="text-danger" style="font-weight: 400;">
                    Direction
                    <a target="_blank" rel="noopener noreferrer" :href="'https://www.google.com/maps/search/?api=1&query=' + item.Latitude + ',' + item.Longitude"><img src="/static/img/icons/maps-direction.png" alt="" style="height:20px;" />
                    </a>

                </span>
            </div>
        </div>
    </div>
    <!-- <div class="row" v-if="IsShowEremitPayPartnerDetails" style="font-size: 14px !important;">
        <div class="col-sm-6">
            <p><strong>{{SelectedEremitPayPartner.TerminalName}}</strong></p>
            <span>{{SelectedEremitPayPartner.Address}}</span><br /><br />
            <p><u><strong>Opening Hours</strong></u></p>
            <div class="row" v-for="item in SelectedEremitPayPartner.TerminalOpeningHours" :key="item.Id">
                <span class="col-sm-4">{{item.DayOfWeek}}</span>
                <span class="col-sm-8">{{item.OpeningHour}} - {{item.ClosingHour}}</span>
            </div><br />
            <span>
                <a target="_blank" rel="noopener noreferrer" :href="'https://www.google.com/maps/search/?api=1&query=' + SelectedEremitPayPartner.Latitude + ',' + SelectedEremitPayPartner.Longitude"><img src="/static/img/google-maps.png" alt="" style="height:20px;" /></a>
                <a target="_blank" rel="noopener noreferrer" :href="'https://www.waze.com/livemap?ll=' + SelectedEremitPayPartner.Latitude + ',' + SelectedEremitPayPartner.Longitude"><img src="/static/img/waze.png" alt="" style="height:20px;" /></a>
                <strong>Phone: </strong> {{SelectedEremitPayPartner.PhoneNumber}}
            </span>
        </div>
    </div> -->
</div>
</template>

<script>
import GoogleMap from "../../components/GoogleMap"
import Base from "../../shared/Base.vue";

export default {
    name: "gmap",
    props: ["userdetails"],
    extends: Base,
    components: {
        GoogleMap
    },
    data() {
        return {
            PartnerList: [],

        }
    },
    created(){
        console.log('a')
        this.getEremitPartnerList({});

    },
    watch: {
        // userdetails: function (newvalue) {
        //     this.PartnerList = newvalue;
        // },

    },
    methods: {
        onSearchMap: function (e) {
            let mapDetails = {};
            mapDetails.MapAddress = e.SearchMapAddress;
            mapDetails.Location = null;
            mapDetails.SearchLocation = e.SearchLocation;
            mapDetails.Radius = e.Radius;
            mapDetails.SearchKeyword = e.SearchKeyword;
            this.getEremitPartnerList(mapDetails);
        },
        onMapMarkerSelect: function (e) {
            this.SelectedEremitPayPartner = this.PartnerList.find(x => x.Id == e);
            this.IsShowEremitPayPartnerDetails = true;
        },
        getEremitPartnerList: function (val) {
            let loc = [];
            // let partnerDetails = null;
            // if (val.Location)
            //     loc = val.Location.split(',');
            // else if (val.SearchLocation)
            //     loc = val.SearchLocation.split(',');

            let data = {
                SearchKeyword: val.SearchKeyword
            }
            this.$http.post("payment/staging/getpartnerslist", data).then(result => {
                this.PartnerList = result.body;
            });
        }
    }
}
</script>

<style>
.partner-info-details {
    height: 250px;
    overflow-y: scroll;
    padding: 10px;
}
.partner-address p{
    font-size: 14px !important;
}
.partner-address span{
    font-size: 13px !important;
}
.partner-info-details .partner-address {
    margin-bottom: 4px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 4px;
    background: #fafafa;
}
</style>
